

$(document).ready(function() {
  // shop
  $(".m_shop_sp").on("click", function() {
    $(".sm_shop_sp").fadeIn();
    $(this).addClass("active");

    // 逆側は閉じる
    $(".sm_collection_sp").fadeOut();
    $(".m_collection_sp").removeClass("active");
  });

  // collection
  $(".m_collection_sp").on("click", function() {
    $(".sm_collection_sp").fadeIn();
    $(this).addClass("active");

    // 逆側は閉じる
    $(".sm_shop_sp").fadeOut();
    $(".m_shop_sp").removeClass("active");
  });
});




$(function() {
$(".sub_grand_menu_top").click(function(){
$(".sub_grand_menu_top .button-navi-icon").addClass("close");
$(".button-close").css('z-index', '9999');

$("#sp_menu").fadeIn();
$('.sub_grand_menu_top p').text("Close");
});
});





$(function() {
$(".button-close").click(function(){
$(".sub_grand_menu_top .button-navi-icon").removeClass("close");
$(".button-close").css('z-index', '-9999');
$(".sm_shop_sp").fadeOut();
 $(".m_shop_sp").removeClass("active");
$("#sp_menu").fadeOut();
$('.sub_grand_menu_top p').text("Menu");
});
});




$(function () {
  var KEY = 'first_view_last_shown';
  var now = Date.now();
  var ONE_HOUR = 60 * 60 * 1000;

  var lastShown = localStorage.getItem(KEY);

  var $fv = $('.first_view');
  var $body = $('body');

  // ---- 初回（localStorageが空） ----
  if (!lastShown) {
    showFirstView();
    return;
  }

  // ---- 1時間経過したら再表示 ----
  if (now - Number(lastShown) > ONE_HOUR) {
    showFirstView();
    return;
  }

  // ---- それ以外は非表示 + body に no_intro ----
  hideFirstView();


  function showFirstView() {
    $fv.show(); // 必要なら fadeIn()
    $body.removeClass('no_intro');
    localStorage.setItem(KEY, now);
  }

  function hideFirstView() {
    $fv.hide(); // 必要なら fadeOut()
    $body.addClass('no_intro');
  }
});






















